import React, { useContext } from 'react';
import { Box } from '@mui/material';
import PropTypes from 'prop-types';
import useStyles from './styles';
import PlanningButton from '../components/common/PlanningButton';
import { PlanContext } from '../context/PlanContext';

const ConstructingVenturePortfolio = ({
  image,
  buttonText,
  onContinue,
  isMobile = false,
}) => {
  const classes = useStyles();
  const { planningButtonLoading } = useContext(PlanContext);

  return (
    <Box className={classes.preamblePageContainer}>
      <img
        src={image}
        alt="Constructing Venture Portfolio"
        className={classes.image}
      />
      <div className={classes.continueButton}>
        <PlanningButton
          text={buttonText}
          onClick={onContinue}
          isLoading={planningButtonLoading}
          disabled={planningButtonLoading}
          width={isMobile ? '250px' : '350px'}
        />
      </div>
    </Box>
  );
};

ConstructingVenturePortfolio.propTypes = {
  image: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired,
  onContinue: PropTypes.func.isRequired,
  isMobile: PropTypes.bool,
};

ConstructingVenturePortfolio.defaultProps = {
  isMobile: false,
};

export default ConstructingVenturePortfolio;
